"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
exports.Text = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var bold = _a.bold, children = _a.children, className = _a.className, _c = _a.el, TextElement = _c === void 0 ? 'p' : _c, headline = _a.headline, inline = _a.inline, italic = _a.italic, _d = _a.size, size = _d === void 0 ? 3 : _d, subdued = _a.subdued, props = __rest(_a, ["bold", "children", "className", "el", "headline", "inline", "italic", "size", "subdued"]);
    react_1.default.useEffect(function () {
        console.warn('@servicetitan/design-system: The Text component will be deprecated. Please use Headline, BodyText, or Eyebrow component instead.');
        if (!headline)
            return;
        console.warn('@servicetitan/design-system: The `headline` prop of the Text component has been deprecated. Please use `bold` instead.');
    });
    var TextClasses = classnames_1.default('Text', className, (_b = {},
        _b["fs-" + size] = !inline,
        _b['fw-bold'] = bold || headline,
        _b['fw-normal'] = !bold && bold != null,
        _b['d-i'] = inline,
        _b['fs-italic'] = italic,
        _b['fs-normal'] = !italic && italic != null,
        _b['c-neutral-90'] = subdued,
        _b['ff-display lh-display fw-bold'] = size === 7 || size === '7',
        _b));
    if (size === 6 || size === '6') {
        var headlineProps = __assign({ children: children,
            className: className,
            inline: inline,
            italic: italic,
            subdued: subdued }, props);
        return (react_1.default.createElement(__1.Headline, __assign({ ref: ref, size: "xlarge", el: TextElement }, headlineProps)));
    }
    return (react_1.default.createElement(TextElement, __assign({ ref: ref, className: TextClasses }, props), children));
});
//# sourceMappingURL=Text.js.map